import { useSelector } from 'react-redux';

import useSWR from "swr";

import { Box } from "@mui/material";
import Grid from '@mui/material/Grid';

import ImageCard from '../../components/ImageCard';
import Loader from '../../components/Loader';
import ListPage from '../../layouts/ListPage';
import LazyLoad from 'react-lazyload';

import { videoToolkitFetcher } from "../../common/utils/fetcher";
import { useCheckVideoToolsEnabled } from '../../common/hooks/useCheckVideoToolsEnabled';

const SmartVideoRenders = () => {
  const retailer = useSelector(state => state.retailer);

  const videoToolsEnabled = useCheckVideoToolsEnabled();

  const { data, isLoading } = useSWR({
    url: 'Batch_Renders',
    sort: '-created',
    fields: '*, render_brand.logo',
    ...(!videoToolsEnabled ? {
      filter: {
        _and: [
          {
            render_brand: {
              id: {
                _eq: retailer?.smart_videos_brand?.id,
              }
            }
          }
        ]
      }
    } : {}),
    meta: '*',
  }, videoToolkitFetcher);

  let items = [];
  let itemsMeta = {};

  if (data) {
    items = data.data;
    itemsMeta = data.meta;
  }

  const summaryValues = [
    {
      label: 'Total',
      value: itemsMeta?.filter_count?.toLocaleString() || '-',
    },
  ];

  if (isLoading) {
    return <Loader />;
  }

  return (
    <ListPage
      title='Smart Video Renders'
      summaries={summaryValues}
      searchStorageKey={'smart-videos-renders'}
      searchOnly={['RENDERS']}
      breadcrumbsLinks={[
        {
          url: '/smart-videos',
          content: 'Smart Videos',
        }
      ]}
    >
      <Box sx={{ flexGrow: 1, my: 3 }}>
        <Grid sx={{ mt: 4 }} container spacing={2}>
          {items?.map((item) => (
            <Grid
              key={item.id}
              item
              xs={12}
              md={3}
              lg={2}
            >
              <Box
                sx={{
                  height: '100%',
                }}
              >
                <LazyLoad
                  height='100%'
                >
                  <ImageCard
                    url={`/smart-videos/renders/${item.id}`}
                    item={{
                      title: item.project,
                      url: item?.render_brand?.logo ? `${process.env.REACT_APP_SHOTSTACK_ADMIN_API_URL}/assets/${item.render_brand.logo}` : ''
                    }}
                  />
                </LazyLoad>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </ListPage>
  )
}

export default SmartVideoRenders